export enum ChatBubbleVariant {
	USER = 'user',
	ASSISTANT = 'assistant',
}
